import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConstantsProject } from '@web/project/shared/constants.class';

@Component({
  selector: 'web-section-title-dinamic',
  templateUrl: './section-title-dinamic.component.html',
  styleUrls: ['./section-title-dinamic.component.scss'],
})
export class SectionTitleDinamicComponent implements OnInit {

  @Input() title: string;
  @Input() observatoryID: number;
  @Input() icon: string;
  @Input() svgIcon: string;
  @Input() subtype: number;
  @Output('openMenuClick') openMenuClick = new EventEmitter<boolean>();

  ngOnInit() {

  }

  onClick() {
    this.openMenuClick.emit(true);
  }
}
